<template>
  <div class="page_all">
    <div class="return_link"></div>   
    <div class="page_header">
      <div class="title">訓練</div>
      <div>
        <button class="btn_plus" v-on:click="pushAdd()">＋</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_push_name">訓練名</th>
            <!-- <th class="th_title">タイトル</th>
            <th class="th_area">地域</th> -->
            <th class="th_status">編集</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="push in pushTrainingList" v-bind:key="push.id">
            <td class="td_push_name">
              <router-link v-on:click.native="toPushTrainingList(push.id, push.name)" to="">{{ push.name }}</router-link>
            </td>
            <td class="btn_delete">
              <button class="btn btn-outline-primary btn-sm" @click="updateTraining(push.id)">変更</button>
                <!-- <MyModal @close="closeModal" v-if="modal">
                <p>Vue.js Modal Window!</p>
                <div><input v-model="message"></div>
                <template slot="footer">
                  <button @click="doSend">送信</button>
                  <button @click="doSend">送信</button>
                </template>
              </MyModal> -->
              <button class="btn_delete" @click="deleteTraining(push.id)">☓</button>
            </td>
            <!-- <td class="td_title">{{ push.push_title }}</td>
            <td class="td_area">{{ push.areas }}</td>
            <td v-if="push.status == 0" class="td_status">下書き</td>
            <td v-else class="td_status">送信済み</td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
// import MyModal from './tool/MyModal.vue'
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    ConfirmDialog
  },
  // components: { MyModal },
  data() {
    return {
      pushTrainingList: null,
      modal: false,
      message: "",
    }
  },
  mounted() {
    this.getPushTrainingList()
  },
  methods: {
    async getPushTrainingList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'push-training/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.pushTrainingList = response.data
    },
    pushAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'pushNotificationTrainingAdd' })
    },
    toPushTrainingList: function(push_training_id, training_name) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      // PushIdをStoreにセット
      this.$store.commit('setStatePushTrainingId', push_training_id)
      this.$store.commit('setStateTrainingName', training_name)
      this.$router.push({ name: 'pushNotificationTrainingList' })
    },
    openModal() {
      this.modal = true
    },
    closeModal() {
      this.modal = false
    },
    doSend() {
      if (this.message.length > 0) {
        alert(this.message)
        this.message = ''
        this.closeModal()
      } else {
        alert('メッセージを入力してください')
      }
    },
    async deleteTraining(pushId) {
      const push = this.pushTrainingList && this.pushTrainingList.find(push => push.id === pushId) || null;
      if (!push) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${push.name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'push-training/delete', {
          training_id: pushId,
        })
      } catch(err) {
        this.message = err.response.data.errorMessage
      }
      this.getPushTrainingList()
    },
    updateTraining: function(pushId) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      this.$store.commit('setStatePushTrainingId', pushId)
      this.$router.push({ name: 'pushNotificationTrainingAdd' })
    },
  }
}
</script>


<style scoped>
.tbl_main {
  background-color: white;
}
table th.th_push_name {
  width: 190px;
  text-align: left;
  padding-left: 10px;
}
table th.th_title {
  width: 310px;
  text-align: left;
  padding-left: 10px;
}
table th.th_area {
  width: 220px;
  text-align: left;
  padding-left: 10px;
}
table th.th_status {
  width: 80px;
  text-align: center;
}
table td.td_push_name, td.td_title, td.td_area {
  text-align: left;
  padding-left: 10px;
}
table td.td_status {
  text-align: center;
}
.btn_delete {
  /* text-align: left; */
  border-left: none;
  width: 20px;
}
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal_header {
  border-bottom: 1px solid #ddd;
  height: 60%;
}
.modal_title {
  color: black;
  text-align: center;
}
.modal-body {
  margin: 0 auto;
}
.modal_btn_div {
  margin: 0 auto;
}
.modal_btn {
  margin: 0 10px 0 0;
}
</style>